import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SINGLE_OFFICE_MODE } from '../../config';
import TitleTop from '../../common/TitleTop/TitleTop';
import BtnBack from '../../common/BtnBack/BtnBack';

import { StyledReservationError } from './styles/StyledReservationError';

class ReservationError extends Component {
  render() {
    const { officeId, serviceId, } = this.props;
    const { 
      blacklist,
      timeLimit,
      nonDuplicatedEmail,
    } = this.props.error;

    let errorMessage;
    let icon;

    if (!blacklist) {
      errorMessage = "Tento e-mail je blokován!";
      icon = 'fa-ban';

    } else if (!timeLimit) {
      errorMessage = "Vypršel časový limit pro rezervaci!";
      icon = 'fa-hourglass-o';

    } else if (!nonDuplicatedEmail) {
      errorMessage = "Zadaný e-mail již má vytvořenou rezervaci na vybraný čas. Zadejte prosím jiný e-mail!";
      icon = 'fa-envelope-open';

    } else {
      errorMessage = "Něco se nepovedlo";
      icon = 'fa-exclamation-triangle';
    }

    return (
      <StyledReservationError>

        <BtnBack 
          text="ZPĚT NA VÝBĚR TERMÍNU"
          linkTo={'/office/' + officeId + '/service/' + serviceId}
        />

        <div>
          <TitleTop
            number={SINGLE_OFFICE_MODE ? 3 : 4} 
            title="Rezervace se nezdařila"
          />
          
          <table className="reservation-error-table">
            <tbody>
              <tr>
                <td className="reservation-error-icon">
                  <i className={'fa ' + icon} aria-hidden="true"></i>
                </td>
                <td className="reservation-error-text">
                    <p role="status">{ errorMessage }</p>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
        
      </StyledReservationError>
    );
  }
}


ReservationError.propTypes = {
  error: PropTypes.object.isRequired,
  serviceId: PropTypes.string.isRequired,
  officeId: PropTypes.string.isRequired,
};


export default ReservationError;